import { ObjectNames } from "src/app/shared/constants";

export const USERPREFERENCEMODULES = [
    // {moduleName: 'Stream', modulePath: '/',objectName: ObjectNames.STREAM},
    { moduleName: 'Accounts', modulePath: '/accounts', objectName: ObjectNames.ACCOUNT},
    { moduleName: 'Lead', modulePath: '/leads', objectName: ObjectNames.LEAD},
    { moduleName: 'Case', modulePath: '/cases', objectName: ObjectNames.CASES},
    { moduleName: 'Opportunity', modulePath: '/opportunities', objectName: ObjectNames.OPPORTUNITY},
    { moduleName: 'Territory', modulePath: '/territory', objectName: ObjectNames.TERRITORY},
    { moduleName: 'Routes', modulePath: '/routes', objectName: ObjectNames.ROUTE},
    { moduleName: 'Questionnaire', modulePath: '/questionnaire', objectName: ObjectNames.QUESTIONNAIRE},
    { moduleName: 'Product', modulePath: '/products', objectName: ObjectNames.PRODUCT},
    { moduleName: 'Purchases', modulePath: '/purchases', objectName: ObjectNames.PURCHASE},
    { moduleName: 'SalesOrder', modulePath: '/sales-order', objectName: ObjectNames.SALES_ORDER},
    { moduleName: 'Estimate', modulePath: '/estimates', objectName: ObjectNames.ESTIMATE},
    { moduleName: 'Invoice', modulePath: '/invoicing', objectName: ObjectNames.INVOICE},
    { moduleName: 'Contact', modulePath: '/contacts', objectName: ObjectNames.CONTACT},
    { moduleName: 'CustomerRma', modulePath: '/customer-returns', objectName: ObjectNames.CREDIT_RMA},
    { moduleName: 'CreditMemo', modulePath: '/credit-memo', objectName: ObjectNames.CREDIT_MEMO},
    { moduleName: 'Location', modulePath: '/locations', objectName: ObjectNames.LOCATION},
    { moduleName: 'Finance', modulePath: '/Finance', objectName: ObjectNames.FINANCE},
    { moduleName: 'WorkFlow', modulePath: '/workflow', objectName: ObjectNames.WORKFLOW},
    { moduleName: 'SavedSearch', modulePath: '/saved-searches', objectName: ObjectNames.SavedSearch},
    { moduleName: 'Reports', modulePath: '/reports', objectName:"Report"},
    { moduleName: 'Configuration', modulePath: '/configurations', objectName: ObjectNames.CONFIGURATION}
];

export const THEME_COLORS = {
    red: "#ce1800",
    green: "#9fd037",
    teal: "#12b886",
    blue: "#3ebaf8",
    amber: "#f7cb00",
    purple: "#966af1",
    turquoise: "#2ab1be",
    bluegrey: "#546E7A"
}

export const EDITOR_COLORS: string[] = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466"
];

